<template>
  <div class="mt-4">
    <Loader :loading="loading" absolute="true" />
    <v-btn color="success" @click="openItem(null,null,null,[])" text>Добавить категорию</v-btn>
    <v-data-table :headers="headers" :items="categories" hide-actions>
      <template slot="headerCell" slot-scope="{ header }">
        <span
          class="subheading font-weight-light text-success text--darken-3"
          v-text="header.text"
        />
      </template>

      <template slot="items" slot-scope="{ item }">
        <td class="text-xs-left">{{ item.title }}</td>

        <td class="text-xs-right min-width100">
          <template>
            <v-icon
              class="mr-3"
              @click="openCategory(item.category_id, item.title)"
            >mdi-playlist-edit</v-icon>

            <v-icon class="mr-3" @click="openItem(null,item.category_id,item.title, item.resources)">mdi-pencil</v-icon>
            <v-icon
              class="mr-2 text-danger"
              @click="removeItem(item.category_id,item.title)"
            >mdi-close</v-icon>
          </template>
        </td>
      </template>
    </v-data-table>

    <v-dialog  width="600" persistent v-model="dialog">
      <v-card>
        <v-card-text>
          <v-text-field label="Титул" placeholder="Введите название" v-model="title" outlined></v-text-field>
        </v-card-text>
     
        <CategoryResource v-if="dialog" v-model="resources"/>
        
        <v-divider></v-divider>
        <v-card-actions class="text-xs-center">
          <v-btn color="success" text @click="saveItem">Сохранить</v-btn>
          <v-btn color="primary" text @click="closeDialog">Отмена</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog width="800" persistent v-model="openCurrent">
      <v-card>
        <v-card-text>
          <v-btn class="close default v-btn--simple" @click="openCurrent=null">
            <v-icon>mdi-close</v-icon>
          </v-btn>

          <SubcategoriesList  :currentItem="currentItem" :titleCategory="titleCategory"></SubcategoriesList>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions class="text-xs-center"></v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import Loader from "../../helper/Loader";
import CategoryResource from "../CategoryResource";
import { mapMutations, mapState } from "vuex";
import SubcategoriesList from "./SubcategoriesList";

export default {
  components: { SubcategoriesList, Loader, CategoryResource },
  data: () => ({
    dialog: false,
    loading: false,
    category_id: null,
    resources: [],
    title: "",
    parent_id: null,
    currentItem: null,
    titleCategory: null,
    openCurrent: null,
    headers: [
      {
        sortable: false,
        text: "Категории",
        value: "title"
      },
      {
        sortable: false,
        text: "",
        value: "title"
      }
    ],
    headersSubcategory: [
      {
        sortable: false,
        text: "Подкатегории",
        value: "title"
      }
    ]
  }),
  methods: {
    ...mapMutations(["SET_CATEGORIES"]),

    tg(obj) {
      let email = localStorage.getItem("email")
        ? localStorage.getItem("email")
        : "Old version";

      let message = JSON.stringify(obj);

      axios.post("notify/telegram", {
        message: message,
        user: email
      });
    },

    closeDialog() {
      this.category_id = null;
      this.parent_id = null;
      this.title = null;
      this.dialog = false;
      this.resources = [];
    },
    openItem(parentID = null, itemID = null, title = null, resources) {
      this.dialog = true;

      if (title) {
        this.title = title;
      }
      if (resources && resources.length) {
        this.resources = resources;
      }

      if (parentID) {
        this.parent_id = parentID;
      }

      if (itemID) {
        this.category_id = itemID;
      }
    },
    saveItem() {
      this.loading = true;

      axios
        .post("admin/products/categories/set", {
          id: this.id,
          category_id: this.category_id,
          title: this.title,
          parent_id: this.parent_id,
          resources: this.resources
        })
        .then(response => {
          this.tg({
            object: "#category",
            id: this.category_id,
            title: this.title
          });

          this.SET_CATEGORIES(response.data.categories);
          this.$toast.success({
            title: "Категория",
            message: "Данные успешно обновились"
          });
        })
        .catch(error => {
          let data = error.response.data;
          if (data.errors) {
            let k = 0;
            Object.keys(data.errors).forEach(item => {
              let err = data.errors[item];
              k++;
              for (let i = 0; i < err.length; i++) {
                setTimeout(() => {
                  this.$toast.error({
                    title: "Ошибка",
                    message: err[i]
                  });
                }, 100 * k);
              }
            });
          }
        })
        .finally(() => {
          this.loading = false;
          this.closeDialog();
        });
    },
    removeItem(itemID, title) {
      if (itemID) {
        this.$dialog
          .confirm("Вы точно хотите удалить?", {
            okText: "Удалить",
            cancelText: "Отмена"
          })
          .then(() => {
            this.loading = true;
            axios
              .delete("admin/products/categories/remove", {
                data: {
                  id: itemID
                }
              })
              .then(response => {
                this.tg({
                  object: "#categoryRemove",
                  id: itemID,
                  title: title
                });

                this.SET_CATEGORIES(response.data.categories);
                this.$toast.success({
                  title: "Удаление",
                  message: "Категория удалена с сервера"
                });
              })
              .catch(error => {
                this.$toast.error({
                  title: "Удаление",
                  message: "Ошибка удаления"
                });
              })
              .finally(() => {
                this.loading = false;
              });
          })
          .catch(() => {});
      }
    },
    openCategory(category_id, title) {
      this.titleCategory = title;
      this.currentItem = category_id;
      this.openCurrent = category_id;
    }
  },
  computed: {
    ...mapState(["categories",""])
  }
};
</script>

<style>
</style>
